<template>
<div class="prize section" id="prize">
  <div class="layout-content">
    <SubTitle :text="title" :subText="subText" />
    <div class="main">
      <p class="main-title">{{data.desc}}</p>

      <div class="main-content">
        <img class="main-content-img" :src="isMobile ? 'https://static001.geekbang.org/resource/image/3b/y8/3b9daf7881bc04e54fe857beffcafyy8.png' : 'https://static001.geekbang.org/resource/image/ac/2c/ace788eaf6e39a2ff0caf36caee18f2c.png'" alt="">
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SubTitle from '@/components/SubTitle'
import { mapState } from 'vuex'

export default {
  props: ['data'],
  components: {
    SubTitle
  },
  computed: {
    ...mapState([
      'isMobile',
      'isEnLang'
    ]),
    title () {
      return this.isEnLang ? 'AWARDS' : '奖项设置'
    },
    subText () {
      return this.isEnLang ? 'FINTECHATHON' : 'AWARDS'
    }
  }
}
</script>

<style lang="scss" scoped>
.prize {
  position: relative;
  padding: 120px 0 60px;
  background: $bgGrey;

  @include mobile {
    padding: 52px 0 25px;
  }
}

.layout-content {
  position: relative; z-index: 2;
}

.main-title {
  width: 1072px;
  margin: 1px auto 60px;
  font-size: 18px; font-weight: 400;
  color: #000000;
  text-align: center;
  line-height: 35px;

  @include mobile {
    width: 100%;
    margin-bottom: 24px;
    color: #000000;
    font-size: 13px; font-weight: 400;
    text-align: left;
    line-height: 26px;
  }
}

.main-content {
  display: flex; justify-content: center; align-items: center;
  width: 1200px; height: 982px;
  background: #FFFFFF;

  @include mobile {
    width: 100%; height: auto;
  }
}

.main-content-img {
  width: 1036px; height: 817px;

  @include mobile {
    width: 100%; height: 100%;
  }
}
</style>
